import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ActivityList } from '../../shared/ActivityList'
import { mapTransactionToActivity } from '../../shared/mapTransactionToActivity'
import type { RawActivityTransaction } from '../../shared/mapTransactionToActivity'
import { useAdminShell } from '../AdminShellContext'

interface RecentActivityPanelProps {
  activity: RawActivityTransaction[]
  memberEmail: string
}

export function RecentActivityPanel({ activity, memberEmail }: RecentActivityPanelProps) {
  const { t, i18n } = useTranslation()
  const { navigateTo } = useAdminShell()

  const entries = activity.map((tx) => mapTransactionToActivity(tx, t, i18n.language))

  function handleViewAll() {
    navigateTo('AdminRecentActivity', { initialMemberQuery: memberEmail })
  }

  return (
    <View className="rounded-md border border-border bg-canvas-card p-5">
      <View className="flex-row items-center justify-between">
        <Text className="text-lg font-semibold text-primary">
          {t('members.detail.recentActivity.title')}
        </Text>
        {entries.length > 0 ? (
          <Pressable
            onPress={handleViewAll}
            accessibilityRole="link"
            accessibilityLabel={t('members.detail.recentActivity.viewAllAccessibilityLabel')}
          >
            <Text className="text-sm font-medium text-accent">
              {t('members.detail.recentActivity.viewAll')}
            </Text>
          </Pressable>
        ) : null}
      </View>

      {entries.length > 0 ? (
        <ActivityList entries={entries} />
      ) : (
        <Text className="mt-4 text-sm font-normal text-muted">
          {t('members.detail.recentActivity.empty')}
        </Text>
      )}
    </View>
  )
}